type Visibility = 0 | 1

type Payload = {
  type: 'header_VISIBILITY' | 'footer_VISIBILITY'
  value: Visibility
}

interface CustomWindow extends Window {
  ReactNativeWebView?: {
    postMessage: (message: string) => void
  }
  android?: {
    __externalCall: (message: string) => void
  }
  __externalCall?: (message: string) => void
  webkit?: {
    messageHandlers?: {
      callback?: {
        postMessage: (message: string) => void
      }
    }
  }
}

declare const window: CustomWindow

const useNativeAppBridge = () => {
  const isIOS = (): boolean =>
    /iPad|iPhone|iPod/.test(window.navigator.userAgent)

  const sendToApp = (payload: Payload): void => {
    if (window) {
      const encodedData = window?.btoa?.(JSON.stringify(payload))

      if (window?.ReactNativeWebView) {
        window?.ReactNativeWebView?.postMessage(encodedData)
      } else if (window?.android?.__externalCall) {
        window?.android?.__externalCall(encodedData)
      } else if (window?.__externalCall) {
        window?.__externalCall(encodedData)
      } else if (isIOS() && window?.webkit?.messageHandlers?.callback) {
        window?.webkit?.messageHandlers?.callback?.postMessage(encodedData)
      }
    }
  }

  const changeHeaderVisibility = (visibility: Visibility): void => {
    sendToApp({ type: 'header_VISIBILITY', value: visibility })
  }

  const changeFooterVisibility = (visibility: Visibility): void => {
    sendToApp({ type: 'footer_VISIBILITY', value: visibility })
  }

  return { changeHeaderVisibility, changeFooterVisibility }
}

export default useNativeAppBridge
